export const ServiceTypes = {
    UserManager: Symbol('UserManager'),
    AutoMapper: Symbol('AutoMapper'),
    UserManagerSettings: Symbol('UserManagerSettings'),
    ApolloClientIGP: Symbol('ApolloClientIGP'),
    ApolloClientIGPMocked: Symbol('ApolloClientIGPMocked'),
    MessageLocalizer: Symbol('MessageLocalizer'),
    CsvFileAdapter: Symbol('CsvFileAdapter'),
    CsvDocumentBuilder: Symbol('CsvDocumentBuilder'),
    XlsxDocumentBuilder: Symbol('XlsxDocumentBuilder'),
    FileDownloadService: Symbol('FileDownloadService'),
    RestService: Symbol('RestService'),
    RestFetchService: Symbol('RestFetchService'),

    // Entities
    TransactionService: Symbol('TransactionService'),
    UserProfileService: Symbol('UserProfileService'),
    CountryService: Symbol('CountryService'),
    BulkOperationService: Symbol('BulkOperationService'),
    AgentProfileService: Symbol('AgentProfileService'),
    UserActivitySummaryService: Symbol('UserActivitySummaryService'),
    PlayerBonusService: Symbol('PlayerBonusService'),
    BonusCodeService: Symbol('BonusCodeService'),
    BackpackService: Symbol('BackpackService'),
    PlayerReferralService: Symbol('PlayerReferralService'),

    // Strategies
    LoadP2PTransferStrategy: Symbol('LoadP2PTransferStrategy'),
    LoadP2PTransferViaFileStrategy: Symbol('LoadP2PTransferViaFileStrategy'),
    ApplyP2PTransfersStrategy: Symbol('ApplyP2PTransfersStrategy'),
    ValidationP2PTransferStrategy: Symbol('ValidationP2PTransferStrategy'),
    PerformP2PTransfersStrategy: Symbol('PerformP2PTransfersStrategy'),

    // Epic Builders
    UserProfileEpicsBuilder: Symbol('UserProfileEpicsBuilder'),
    DonwloadEpicsBuilder: Symbol('DownloadEpicsBuilder'),
    MessageEpicsBuilder: Symbol('MessageEpicsBuilder'),
    PlayerReferralEpicsBuidler: Symbol('PlayerReferralEpicsBuidler'),
} as const;
